<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useKaleadicalStore } from '@/stores/kaleadical';
import HabitsForm from '@/components/HabitsForm.vue';
// import { storeToRefs } from 'pinia';

const props = defineProps({
    kaleadical: {
        type: Object,
        default: () => ({
            thumbnail: '',
            name: '',
            description: '',
            habits: [],
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const emit = defineEmits(['close-modal']);
const form = ref(props.kaleadical);

form.value.habits = form.value.habits.filter(habit => {
    return habit.name;
});
const toast = useToast();

// import { useOptionsStore } from '@/stores/options';
// const optionsStore = useOptionsStore();

const kaleadicalStore = useKaleadicalStore();
const { storeKaleadical, updateKaleadical } = kaleadicalStore;

const save = async () => {
    try {
        const action = props.mode === 'Create' ? storeKaleadical : updateKaleadical;
        const toastMessage = props.mode === 'Create' ? 'Kaleadical Created' : 'Kaleadical Updated';

        await action({
            ...form.value,
            hash: props.kaleadical.hash,
        });

        toast.success(toastMessage);
        emit('close-modal');
    } catch (error) {
        toast.error('An unexpected error occurred');
    }
};
</script>
<template>
<ModalWrapper>
    <template #header>{{ mode }} {{ $t('label.kaleadical') }}</template>
    <template #subheader>{{ $t('label.create_or_edit') }}</template>

    <form @submit.prevent="save">
        <div class="grid md:grid-cols-2 gap-x-4 gap-y-3">
            <StyledInput
                v-model="form.name"
                name="name"
                :placeholder="$t('label.name')"
                :label="$t('label.name')" />

            <StyledInput
                v-model="form.description"
                name="description"
                :placeholder="$t('label.description')"
                :label="$t('label.description')" />

            <HabitsForm :habits="form.habits"  class="w-full col-span-2" />
            
        </div>
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
